// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BindingExpiration, BindingExpirationSchema } from 'api/gen/BindingExpiration';

const requiredPart = t.interface({
  bindingExpiration: BindingExpirationSchema,
  farmIds: t.union([t.array(t.Integer), t.null]),
  hasAccessToAllFarms: t.boolean,
  hasAccessToAllOrganizationCenters: t.boolean,
  organizationCenterIds: t.union([t.array(t.Integer), t.null]),
  roleId: t.Integer,
  userProfileOrganizationRoleId: t.Integer,
});

export const OrganizationRoleManagementSchema = excess(requiredPart);

export interface OrganizationRoleManagement extends t.TypeOf<typeof OrganizationRoleManagementSchema> {}
